import { Box, IconButton, Input } from '@zillow/constellation-10';
import { IconMinusFilled, IconPlusFilled } from '@zillow/constellation-icons';
import { useMemo } from 'react';

import { TYPES_MAP } from '../../../../constants/ListingCriteriaConstants';
import PetPolicyAndPetFeeCSEvents from '../../../../model/ClickstreamEvent/PetPolicyAndPetFeeCSEvents';

import type { ChangeEvent } from 'react';

type MockEventProps = {
  target: {
    name: string;
    value: string | boolean;
    checked?: string | boolean;
  };
  persist?: () => void;
};

type SaveEvent = ChangeEvent<HTMLInputElement> | MockEventProps;

type Props = {
  name: string;
  value: string;
  onChange?: (event: SaveEvent) => void;
  onMinusClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onPlusClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PetCountInput = ({ name, value, onChange = () => {}, onMinusClick, onPlusClick }: Props) => {
  const dataEventId = useMemo(() => {
    if (name === TYPES_MAP.PET_POLICY_CAT_COUNT) {
      return PetPolicyAndPetFeeCSEvents.NumberOfCatsAllowed.data_event_id;
    }
    if (name === TYPES_MAP.PET_POLICY_SMALL_DOG_COUNT) {
      return PetPolicyAndPetFeeCSEvents.NumberOfSmallDogsAllowed.data_event_id;
    }
    if (name === TYPES_MAP.PET_POLICY_LARGE_DOG_COUNT) {
      return PetPolicyAndPetFeeCSEvents.NumberOfLargeDogsAllowed.data_event_id;
    }
    return undefined;
  }, [name]);

  return (
    <Box
      data-testid="PetCountInputContainer"
      css={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <IconButton
        shape="circle"
        tone="neutral"
        emphasis="bare"
        icon={<IconMinusFilled />}
        name={name}
        size="sm"
        title="Minus"
        onClick={onMinusClick}
        data-eventid={dataEventId}
      />
      <Input
        readOnly
        size="sm"
        placeholder="0"
        name={name}
        value={value}
        onChange={onChange}
        css={{
          width: '48px',
          textAlign: 'center',
        }}
      />
      <IconButton
        shape="circle"
        tone="neutral"
        emphasis="bare"
        icon={<IconPlusFilled />}
        name={name}
        size="sm"
        title="Plus"
        onClick={onPlusClick}
        data-eventid={dataEventId}
      />
    </Box>
  );
};

export default PetCountInput;
